export default __webpack_public_path__ + "static/media/fally_ipupa_amore.efe0fdd5.mp3";